<template>
    <div style="width: 100%; height: 100%">
        <v-divider class="mt-4"></v-divider>
        <div style="width: 100%" class="d-flex justify-end my-4">
            <div style="height: 24px; width: 200px">
                <TrailInputsBtn
                    v-model="selectedExample"
                    :examples="examples"
                />
            </div>
            <SubmitBtn
                :calc="calc"
                :loading="loading"
                @click="calculateClicked"
                class="ml-4"
            />
        </div>
    </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import TrailInputsBtn from './TrailInputsBtn.vue'
import SubmitBtn from './SubmitBtn.vue'

const props = defineProps(['examples', 'loading', 'calc'])
const emit = defineEmits(['example-selected', 'submit'])

const selectedExample = ref(null)

watch(
    selectedExample,
    () => {
        emit('example-selected', selectedExample.value)
    },
    { deep: true }
)

function calculateClicked() {
    emit('submit')
}
</script>
